import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ElementModel } from 'src/app/models/maintenance/element.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ElementService {


  constructor(private _httpClient: HttpClient) { }

  createElement(elementModel: ElementModel): Observable<ElementModel> {
    return this._httpClient.post<ElementModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.element.CreateAsync}`,
      elementModel);
  }

  deleteElement(elementId: number): Observable<ElementModel> {
    return this._httpClient.delete<ElementModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.element.DeleteAsync}/${elementId}`);
  }

  deleteSomeDetails(elementIds: number[]): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.element.DeleteSomeDetailsAsync}`,
      elementIds);
  }

  getAllElementWithPaginationAsync(maintenanceRoutineId: number, componentId: number, page: number, limit: number, columnSort: string | null,
    ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('maintenanceRoutineId', maintenanceRoutineId).set('componentId', componentId).set('page', page)
      .set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.element.GetAllElementWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getElementByCode(maintenanceRoutineId: number, componentId: number, code: number): Observable<ElementModel> {
    return this._httpClient.get<ElementModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.element.GetByCodeAsync}/${maintenanceRoutineId}/${componentId}/${code}`)
  }

  getElementById(id: number): Observable<ElementModel> {
    return this._httpClient.get<ElementModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.element.GetByIdAsync}/${id}`);
  }

  getColumnsAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.element.GetColumnsAsync}`);
  }


  getElementsByComponentIdAsync(componentId: number): Observable<ElementModel[]> {
    return this._httpClient.get<ElementModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.element.GetElementsByComponentIdAsync}/${componentId}`);
  }

  updateElement(elementModel: ElementModel): Observable<ElementModel> {
    return this._httpClient.put<ElementModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.element.UpdateAsync}`,
      elementModel);
  }

}
